import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { Pagination } from '../shared/Constants';

const MAX_RECORDS_PER_REQUEST = 200;

const TEMPLATES_QUERY = gql`
  query($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      assessmentTemplates(first: $first) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

const asmtTemplates = graphql(TEMPLATES_QUERY, {
  name: 'templateQuery',
  options: ({ match }) => ({
    variables: {
      accountId: match.params.aid,
      first: MAX_RECORDS_PER_REQUEST,
    },
  }),
  props: ({ templateQuery }) => {
    const { loading, account, error } = templateQuery;
    const { assessmentTemplates } = account || { assessmentTemplates: {} };
    const processedAsmtTemp = assessmentTemplates && assessmentTemplates.edges
      ? assessmentTemplates.edges.map(jp => jp.node)
      : [];
    return {
      templateQuery: {
        loading,
        error,
        assessmentTemplates: processedAsmtTemp,
      },
    };
  },
});

const RESPONDENT_QUERY = gql`
  query($accountId: ID!, $respondentId: ID!) {
    account(id: $accountId) {
      id
      respondent(id: $respondentId) {
        id
        firstName
        lastName
        email
        locale
      }
    }
  }
`;

const respondentQuery = graphql(RESPONDENT_QUERY, {
  name: 'resQuery',
  options: ({ match }) => {
    const { respondentId, aid } = match.params;
    return {
      variables: {
        respondentId,
        accountId: aid,
      },
    };
  },
});

const JOB_PROFILES_QUERY = gql`
  query GetJobProfiles($accountId: ID!, $last: Int) {
    account(id: $accountId) {
      id
      jobProfiles(last: $last) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

const DEFAULT_JOB_NUMBER = 200;
const getJobProfiles = graphql(JOB_PROFILES_QUERY, {
  name: 'jobProfilesQuery',
  options: ({ match }) => {
    const { aid } = match.params;
    return {
      variables: {
        accountId: aid,
        last: DEFAULT_JOB_NUMBER,
      },
    };
  },
  props: ({ jobProfilesQuery }) => {
    const {
      loading, account, fetchMore, error,
    } = jobProfilesQuery;
    const { jobProfiles } = account || { jobProfiles: {} };
    const processedJobProfiles = jobProfiles && jobProfiles.edges ? jobProfiles.edges.map(jp => jp.node) : [];
    return {
      jobProfilesQuery: {
        loading,
        error,
        jobProfiles: processedJobProfiles,
        getJobProfilesByAssessmentTmpId: (assessmentTemplateId) => {
          const id = assessmentTemplateId !== '' ? assessmentTemplateId : null;
          return fetchMore({
            variables: {
              filter: {
                assessmentTemplateId: id,
              },
              first: Pagination.TEMP_JP_SIZE,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => fetchMoreResult,
          });
        },
      },
    };
  },
});

export const ADD_ASSESSMENT_MUTATE = gql`
  mutation($input: CreateAssessmentInput!) {
    createAssessment(input: $input) {
      assessment {
        id
      }
    }
  }
`;

const addAssessmentMutate = graphql(ADD_ASSESSMENT_MUTATE, { name: 'addAssessment' });

export default compose(
  respondentQuery,
  addAssessmentMutate,
  getJobProfiles,
  asmtTemplates,
);
